import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResolvableMissionTypeForm_ResolvableMissionType_Foau_Mutation =
  graphql(`
    mutation ResolvableMissionTypeForm_ResolvableMissionType_Foau(
      $filter: IdFilterInput!
      $update: ResolvableMissionTypeInput!
      $versionData: VersionDataInput
    ) {
      findOneAndUpdateResolvableMissionType(
        filter: $filter
        update: $update
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export type ResolvableMissionType_Foau_Result = ResultOf<
  typeof ResolvableMissionTypeForm_ResolvableMissionType_Foau_Mutation
>;

export const useUpdateResolvableMissionTypeMutation = () =>
  useGraphQLMutation(
    ResolvableMissionTypeForm_ResolvableMissionType_Foau_Mutation,
  );
